import { TypedUseSelectorHook, useDispatch, useSelector, useStore } from 'react-redux';
import type { Store } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from './index';

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch = () => useDispatch<AppDispatch>();

// For the rare effect that must read the CURRENT state rather than the value
// captured when it rendered — a selector value is a snapshot of its render, so
// two components mounting in the same commit both see the pre-dispatch value.
// useLocations relies on this to keep several consumers from each firing the
// same initial fetch.
export const useAppStore = (): Store<RootState> => useStore<RootState>();
